/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleRateOption } from './VehicleRateOption';
import {
    VehicleRateOptionFromJSON,
    VehicleRateOptionFromJSONTyped,
    VehicleRateOptionToJSON,
    VehicleRateOptionToJSONTyped,
} from './VehicleRateOption';
import type { PointsAmount } from './PointsAmount';
import {
    PointsAmountFromJSON,
    PointsAmountFromJSONTyped,
    PointsAmountToJSON,
    PointsAmountToJSONTyped,
} from './PointsAmount';
import type { CreditCardEarnings } from './CreditCardEarnings';
import {
    CreditCardEarningsFromJSON,
    CreditCardEarningsFromJSONTyped,
    CreditCardEarningsToJSON,
    CreditCardEarningsToJSONTyped,
} from './CreditCardEarnings';
import type { DropoffLogistics } from './DropoffLogistics';
import {
    DropoffLogisticsFromJSON,
    DropoffLogisticsFromJSONTyped,
    DropoffLogisticsToJSON,
    DropoffLogisticsToJSONTyped,
} from './DropoffLogistics';
import type { PickupType } from './PickupType';
import {
    PickupTypeFromJSON,
    PickupTypeFromJSONTyped,
    PickupTypeToJSON,
    PickupTypeToJSONTyped,
} from './PickupType';
import type { VehicleTag } from './VehicleTag';
import {
    VehicleTagFromJSON,
    VehicleTagFromJSONTyped,
    VehicleTagToJSON,
    VehicleTagToJSONTyped,
} from './VehicleTag';
import type { PickupLogistics } from './PickupLogistics';
import {
    PickupLogisticsFromJSON,
    PickupLogisticsFromJSONTyped,
    PickupLogisticsToJSON,
    PickupLogisticsToJSONTyped,
} from './PickupLogistics';

/**
 * 
 * @export
 * @interface VehicleSummary
 */
export interface VehicleSummary {
    /**
     * Supplier code (e.g., ZE for Hertz, AL for Alamo)
     * @type {string}
     * @memberof VehicleSummary
     */
    vendorCode: string;
    /**
     * Supplier display name
     * @type {string}
     * @memberof VehicleSummary
     */
    vendorName?: string;
    /**
     * 4-character ACRISS/SIPP vehicle classification code
     * @type {string}
     * @memberof VehicleSummary
     */
    acrissCode: string;
    /**
     * Vehicle class (Economy, Compact, Standard, etc.)
     * @type {string}
     * @memberof VehicleSummary
     */
    vehicleClass: string;
    /**
     * Vehicle category (Car, SUV, Van, etc.)
     * @type {string}
     * @memberof VehicleSummary
     */
    vehicleCategory: string;
    /**
     * Vehicle description or make/model if available
     * @type {string}
     * @memberof VehicleSummary
     */
    description?: string;
    /**
     * Transmission type (Automatic, Manual)
     * @type {string}
     * @memberof VehicleSummary
     */
    transmissionType?: string;
    /**
     * Fuel type (Petrol, Diesel, Electric, Hybrid)
     * @type {string}
     * @memberof VehicleSummary
     */
    fuelType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSummary
     */
    airConditioning?: boolean;
    /**
     * Number of doors
     * @type {number}
     * @memberof VehicleSummary
     */
    doorCount?: number;
    /**
     * Estimated passenger capacity
     * @type {number}
     * @memberof VehicleSummary
     */
    passengerCount?: number;
    /**
     * Estimated luggage capacity
     * @type {number}
     * @memberof VehicleSummary
     */
    bagCount?: number;
    /**
     * Rate amount per period (numeric string with currency prefix, e.g., USD61.71). The period is indicated by rate_period (defaults to Daily).
     * @type {string}
     * @memberof VehicleSummary
     */
    dailyRate?: string;
    /**
     * Estimated total rate for the rental period
     * @type {string}
     * @memberof VehicleSummary
     */
    totalRate?: string;
    /**
     * Billing period for the rate (Daily, Weekly, Monthly, Weekend). Defaults to Daily when not specified by the supplier.
     * @type {string}
     * @memberof VehicleSummary
     */
    ratePeriod?: VehicleSummaryRatePeriodEnum;
    /**
     * Currency code
     * @type {string}
     * @memberof VehicleSummary
     */
    currency?: string;
    /**
     * Rate code for booking
     * @type {string}
     * @memberof VehicleSummary
     */
    rateCode: string;
    /**
     * Rate category (Standard, Promotional, etc.)
     * @type {string}
     * @memberof VehicleSummary
     */
    rateCategory?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSummary
     */
    unlimitedMileage?: boolean;
    /**
     * Opaque token for booking this rate
     * @type {string}
     * @memberof VehicleSummary
     */
    rateToken?: string;
    /**
     * Opaque inventory token
     * @type {string}
     * @memberof VehicleSummary
     */
    inventoryToken?: string;
    /**
     * Pickup location code
     * @type {string}
     * @memberof VehicleSummary
     */
    pickupLocation?: string;
    /**
     * Human-readable pickup location address or name (e.g., "123 Main St, San Francisco, CA"). Populated from Travelport AddressInfo for city searches.
     * @type {string}
     * @memberof VehicleSummary
     */
    locationName?: string;
    /**
     * Latitude of the rental facility pickup location. Geocoded from the facility address.
     * @type {number}
     * @memberof VehicleSummary
     */
    pickupLatitude?: number;
    /**
     * Longitude of the rental facility pickup location. Geocoded from the facility address.
     * @type {number}
     * @memberof VehicleSummary
     */
    pickupLongitude?: number;
    /**
     * Whether this card is an airport desk or an off-airport city desk (GON-5966 unified search). Used by the FE to badge city-desk results.
     * @type {string}
     * @memberof VehicleSummary
     */
    deskKind?: VehicleSummaryDeskKindEnum;
    /**
     * Street address of the rental desk when known (off-airport city desks), e.g. "310 E 48TH ST, NYC". Null for airport terminal desks.
     * @type {string}
     * @memberof VehicleSummary
     */
    deskAddress?: string;
    /**
     * Travelport vendor location number for this desk (the PickupLocationNumber pin). Lets booking target the exact city desk the user picked.
     * @type {string}
     * @memberof VehicleSummary
     */
    vendorLocationId?: string;
    /**
     * Travelport pickup search type that produced this result (e.g. CityCenterDowntown for Standard CCD legs). Internal booking provenance; not used for display classification.
     * @type {string}
     * @memberof VehicleSummary
     */
    pickupSearchType?: string;
    /**
     * True when this result's metro quotes city desks one-way only (same-city round trip is unavailable at the vendor layer, e.g. Manhattan). Drives the FE one-way upsell. Null/false otherwise.
     * @type {boolean}
     * @memberof VehicleSummary
     */
    onewayOnly?: boolean;
    /**
     * 
     * @type {Array<VehicleTag>}
     * @memberof VehicleSummary
     */
    tags?: Array<VehicleTag>;
    /**
     * Whether a discount code or promotional rate was applied to this result
     * @type {boolean}
     * @memberof VehicleSummary
     */
    discountApplied?: boolean;
    /**
     * 
     * @type {PickupType}
     * @memberof VehicleSummary
     */
    pickupType?: PickupType;
    /**
     * 
     * @type {PickupLogistics}
     * @memberof VehicleSummary
     */
    pickupLogistics?: PickupLogistics;
    /**
     * 
     * @type {DropoffLogistics}
     * @memberof VehicleSummary
     */
    dropoffLogistics?: DropoffLogistics;
    /**
     * Base rental total before taxes and fees (currency-prefixed, e.g., USD150.00). Null when not available from the supplier.
     * @type {string}
     * @memberof VehicleSummary
     */
    baseTotal?: string;
    /**
     * Mandatory taxes and fees included in the total rate (currency-prefixed, e.g., USD36.00). Null when not available from the supplier.
     * @type {string}
     * @memberof VehicleSummary
     */
    taxesFeesTotal?: string;
    /**
     * Relative pickup speed tier compared to other results in this search. FASTER means this vendor has shorter wait than most, SLOWER means longer. Only populated for airport pickups when there is meaningful spread between vendors.
     * @type {string}
     * @memberof VehicleSummary
     */
    estimatedWaitLevel?: VehicleSummaryEstimatedWaitLevelEnum;
    /**
     * Human-readable pickup speed label (e.g., "Faster pickup", "Slower pickup"). Only populated for airport pickups when there is meaningful spread.
     * @type {string}
     * @memberof VehicleSummary
     */
    estimatedWaitLabel?: string;
    /**
     * Explanation of why this vendor is faster or slower (e.g., "Your Hertz membership lets you skip the counter. On-airport facility"). Shown in a popover when the user taps the badge.
     * @type {string}
     * @memberof VehicleSummary
     */
    estimatedWaitDetail?: string;
    /**
     * URL to a photo of the vehicle or vehicle class, from the rental vendor via Travelport.
     * @type {string}
     * @memberof VehicleSummary
     */
    imageUrl?: string;
    /**
     * All available rate options for this vehicle from parallel searches. When present, the top-level rate fields (daily_rate, total_rate, etc.) contain the best (cheapest) option.
     * @type {Array<VehicleRateOption>}
     * @memberof VehicleSummary
     */
    rates?: Array<VehicleRateOption>;
    /**
     * Whether one-way drop-off charges are already included in the rate. True=included, False=not included (additional charge applies), null=not applicable or unknown.
     * @type {boolean}
     * @memberof VehicleSummary
     */
    dropOffChargesIncluded?: boolean;
    /**
     * Additional one-way drop-off fee when drop_off_charges_included is False (currency-prefixed, e.g., USD25.00).
     * @type {string}
     * @memberof VehicleSummary
     */
    dropOffCharge?: string;
    /**
     * Accepted payment card codes for this vendor (e.g. VI=Visa, MC=Mastercard, AX=Amex, DS=Discover, DC=Diners Club, JCB=JCB).
     * @type {Array<string>}
     * @memberof VehicleSummary
     */
    acceptedPayments?: Array<string>;
    /**
     * 
     * @type {PointsAmount}
     * @memberof VehicleSummary
     */
    earningsPoints?: PointsAmount;
    /**
     * Credit-card points the user would earn on this rental spend, per MX-synced card
     * (best card first). Empty/absent for anonymous users or users with no synced cards.
     * Parallel to earnings_points (loyalty); the unit is points/cash per card.
     * 
     * @type {Array<CreditCardEarnings>}
     * @memberof VehicleSummary
     */
    syncedCardEarnings?: Array<CreditCardEarnings>;
}


/**
 * @export
 */
export const VehicleSummaryRatePeriodEnum = {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Weekend: 'Weekend'
} as const;
export type VehicleSummaryRatePeriodEnum = typeof VehicleSummaryRatePeriodEnum[keyof typeof VehicleSummaryRatePeriodEnum];

/**
 * @export
 */
export const VehicleSummaryDeskKindEnum = {
    Airport: 'airport',
    City: 'city'
} as const;
export type VehicleSummaryDeskKindEnum = typeof VehicleSummaryDeskKindEnum[keyof typeof VehicleSummaryDeskKindEnum];

/**
 * @export
 */
export const VehicleSummaryEstimatedWaitLevelEnum = {
    Faster: 'FASTER',
    Slower: 'SLOWER'
} as const;
export type VehicleSummaryEstimatedWaitLevelEnum = typeof VehicleSummaryEstimatedWaitLevelEnum[keyof typeof VehicleSummaryEstimatedWaitLevelEnum];


/**
 * Check if a given object implements the VehicleSummary interface.
 */
export function instanceOfVehicleSummary(value: object): value is VehicleSummary {
    if (!('vendorCode' in value) || value['vendorCode'] === undefined) return false;
    if (!('acrissCode' in value) || value['acrissCode'] === undefined) return false;
    if (!('vehicleClass' in value) || value['vehicleClass'] === undefined) return false;
    if (!('vehicleCategory' in value) || value['vehicleCategory'] === undefined) return false;
    if (!('rateCode' in value) || value['rateCode'] === undefined) return false;
    return true;
}

export function VehicleSummaryFromJSON(json: any): VehicleSummary {
    return VehicleSummaryFromJSONTyped(json, false);
}

export function VehicleSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'vendorCode': json['vendor_code'],
        'vendorName': json['vendor_name'] == null ? undefined : json['vendor_name'],
        'acrissCode': json['acriss_code'],
        'vehicleClass': json['vehicle_class'],
        'vehicleCategory': json['vehicle_category'],
        'description': json['description'] == null ? undefined : json['description'],
        'transmissionType': json['transmission_type'] == null ? undefined : json['transmission_type'],
        'fuelType': json['fuel_type'] == null ? undefined : json['fuel_type'],
        'airConditioning': json['air_conditioning'] == null ? undefined : json['air_conditioning'],
        'doorCount': json['door_count'] == null ? undefined : json['door_count'],
        'passengerCount': json['passenger_count'] == null ? undefined : json['passenger_count'],
        'bagCount': json['bag_count'] == null ? undefined : json['bag_count'],
        'dailyRate': json['daily_rate'] == null ? undefined : json['daily_rate'],
        'totalRate': json['total_rate'] == null ? undefined : json['total_rate'],
        'ratePeriod': json['rate_period'] == null ? undefined : json['rate_period'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'rateCode': json['rate_code'],
        'rateCategory': json['rate_category'] == null ? undefined : json['rate_category'],
        'unlimitedMileage': json['unlimited_mileage'] == null ? undefined : json['unlimited_mileage'],
        'rateToken': json['rate_token'] == null ? undefined : json['rate_token'],
        'inventoryToken': json['inventory_token'] == null ? undefined : json['inventory_token'],
        'pickupLocation': json['pickup_location'] == null ? undefined : json['pickup_location'],
        'locationName': json['location_name'] == null ? undefined : json['location_name'],
        'pickupLatitude': json['pickup_latitude'] == null ? undefined : json['pickup_latitude'],
        'pickupLongitude': json['pickup_longitude'] == null ? undefined : json['pickup_longitude'],
        'deskKind': json['desk_kind'] == null ? undefined : json['desk_kind'],
        'deskAddress': json['desk_address'] == null ? undefined : json['desk_address'],
        'vendorLocationId': json['vendor_location_id'] == null ? undefined : json['vendor_location_id'],
        'pickupSearchType': json['pickup_search_type'] == null ? undefined : json['pickup_search_type'],
        'onewayOnly': json['oneway_only'] == null ? undefined : json['oneway_only'],
        'tags': json['tags'] == null ? undefined : ((json['tags'] as Array<any>).map(VehicleTagFromJSON)),
        'discountApplied': json['discount_applied'] == null ? undefined : json['discount_applied'],
        'pickupType': json['pickup_type'] == null ? undefined : PickupTypeFromJSON(json['pickup_type']),
        'pickupLogistics': json['pickup_logistics'] == null ? undefined : PickupLogisticsFromJSON(json['pickup_logistics']),
        'dropoffLogistics': json['dropoff_logistics'] == null ? undefined : DropoffLogisticsFromJSON(json['dropoff_logistics']),
        'baseTotal': json['base_total'] == null ? undefined : json['base_total'],
        'taxesFeesTotal': json['taxes_fees_total'] == null ? undefined : json['taxes_fees_total'],
        'estimatedWaitLevel': json['estimated_wait_level'] == null ? undefined : json['estimated_wait_level'],
        'estimatedWaitLabel': json['estimated_wait_label'] == null ? undefined : json['estimated_wait_label'],
        'estimatedWaitDetail': json['estimated_wait_detail'] == null ? undefined : json['estimated_wait_detail'],
        'imageUrl': json['image_url'] == null ? undefined : json['image_url'],
        'rates': json['rates'] == null ? undefined : ((json['rates'] as Array<any>).map(VehicleRateOptionFromJSON)),
        'dropOffChargesIncluded': json['drop_off_charges_included'] == null ? undefined : json['drop_off_charges_included'],
        'dropOffCharge': json['drop_off_charge'] == null ? undefined : json['drop_off_charge'],
        'acceptedPayments': json['accepted_payments'] == null ? undefined : json['accepted_payments'],
        'earningsPoints': json['earnings_points'] == null ? undefined : PointsAmountFromJSON(json['earnings_points']),
        'syncedCardEarnings': json['synced_card_earnings'] == null ? undefined : ((json['synced_card_earnings'] as Array<any>).map(CreditCardEarningsFromJSON)),
    };
}

export function VehicleSummaryToJSON(json: any): VehicleSummary {
    return VehicleSummaryToJSONTyped(json, false);
}

export function VehicleSummaryToJSONTyped(value?: VehicleSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vendor_code': value['vendorCode'],
        'vendor_name': value['vendorName'],
        'acriss_code': value['acrissCode'],
        'vehicle_class': value['vehicleClass'],
        'vehicle_category': value['vehicleCategory'],
        'description': value['description'],
        'transmission_type': value['transmissionType'],
        'fuel_type': value['fuelType'],
        'air_conditioning': value['airConditioning'],
        'door_count': value['doorCount'],
        'passenger_count': value['passengerCount'],
        'bag_count': value['bagCount'],
        'daily_rate': value['dailyRate'],
        'total_rate': value['totalRate'],
        'rate_period': value['ratePeriod'],
        'currency': value['currency'],
        'rate_code': value['rateCode'],
        'rate_category': value['rateCategory'],
        'unlimited_mileage': value['unlimitedMileage'],
        'rate_token': value['rateToken'],
        'inventory_token': value['inventoryToken'],
        'pickup_location': value['pickupLocation'],
        'location_name': value['locationName'],
        'pickup_latitude': value['pickupLatitude'],
        'pickup_longitude': value['pickupLongitude'],
        'desk_kind': value['deskKind'],
        'desk_address': value['deskAddress'],
        'vendor_location_id': value['vendorLocationId'],
        'pickup_search_type': value['pickupSearchType'],
        'oneway_only': value['onewayOnly'],
        'tags': value['tags'] == null ? undefined : ((value['tags'] as Array<any>).map(VehicleTagToJSON)),
        'discount_applied': value['discountApplied'],
        'pickup_type': PickupTypeToJSON(value['pickupType']),
        'pickup_logistics': PickupLogisticsToJSON(value['pickupLogistics']),
        'dropoff_logistics': DropoffLogisticsToJSON(value['dropoffLogistics']),
        'base_total': value['baseTotal'],
        'taxes_fees_total': value['taxesFeesTotal'],
        'estimated_wait_level': value['estimatedWaitLevel'],
        'estimated_wait_label': value['estimatedWaitLabel'],
        'estimated_wait_detail': value['estimatedWaitDetail'],
        'image_url': value['imageUrl'],
        'rates': value['rates'] == null ? undefined : ((value['rates'] as Array<any>).map(VehicleRateOptionToJSON)),
        'drop_off_charges_included': value['dropOffChargesIncluded'],
        'drop_off_charge': value['dropOffCharge'],
        'accepted_payments': value['acceptedPayments'],
        'earnings_points': PointsAmountToJSON(value['earningsPoints']),
        'synced_card_earnings': value['syncedCardEarnings'] == null ? undefined : ((value['syncedCardEarnings'] as Array<any>).map(CreditCardEarningsToJSON)),
    };
}

